/**
 * 저장 실패 알림(T-2.06, ADV-C02). 이전 저장본은 그대로이고 편집 내용은 메모리에 있으므로
 * 사용자가 JSON으로 내보낼 수 있게 창 맨 위 줄 바로 아래에 둔다.
 */
import { Dismiss16Regular, ErrorCircle16Regular } from "@fluentui/react-icons";
import { makeStyles, tokens } from "@fluentui/react-components";
import { useState } from "react";
import { FuiButton } from "@/components/fui-control";
import { exportRescueCopy } from "@/desktop/DesktopRuntime";
import { chromeHeaderProps } from "@/shell/chrome-header";
import { dismissSaveFailure, useSaveHealth } from "@/store/save-health";

const useStyles = makeStyles({
  bar: {
    display: "flex",
    alignItems: "center",
    gap: tokens.spacingHorizontalS,
    flexShrink: 0,
    minHeight: "32px",
    padding: `${tokens.spacingVerticalXXS} ${tokens.spacingHorizontalM}`,
    backgroundColor: tokens.colorStatusDangerBackground1,
    borderBottom: `1px solid ${tokens.colorStatusDangerBorder1}`,
    color: tokens.colorNeutralForeground1,
    fontSize: tokens.fontSizeBase300,
    fontWeight: tokens.fontWeightRegular,
  },
  icon: { color: tokens.colorStatusDangerForeground1, flexShrink: 0 },
  text: { flex: 1, minWidth: 0 },
});

export function SaveErrorBanner() {
  const styles = useStyles();
  const failure = useSaveHealth((s) => s.failure);
  const dismissed = useSaveHealth((s) => s.dismissed);
  const [busy, setBusy] = useState(false);
  if (!failure || dismissed) return null;
  return (
    <div className={styles.bar} role="alert" {...chromeHeaderProps}>
      <ErrorCircle16Regular className={styles.icon} aria-hidden />
      <span className={styles.text}>
        {failure.message}. 이전에 저장한 내용은 그대로 있어요. {failure.quota ? "큰 첨부를 줄이거나 " : ""}지금 플랜을 JSON으로 내보내 두세요.
      </span>
      <FuiButton
        appearance="primary"
        disabled={busy}
        onClick={async () => {
          setBusy(true);
          try {
            await exportRescueCopy();
          } finally {
            setBusy(false);
          }
        }}
      >
        {busy ? "내보내는 중…" : "JSON 내보내기"}
      </FuiButton>
      <FuiButton appearance="subtle" icon={<Dismiss16Regular />} aria-label="알림 닫기" onClick={dismissSaveFailure} />
    </div>
  );
}
